import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import { EMPTY_OBJECT, EMPTY_ARRAY, EVENT_TYPES, errorMessages } from '../../constants/globalConstants'
import { QRCodeSVG } from 'qrcode.react'
import moment from 'moment'
import NoImage from './NoImage'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import moreIcon from '../../assets/img/more-facility.svg'
import { globalKeyStore } from '../../redux/actions/globalState'
import { getFormattedAmountNumber, getPriceBreakdown, isTimeBeforeCurrentFacilityTime } from '../../utils/helper'
// import CONSTANTS from '../../redux/constants'

function EventCard({ allFacility, eventIndex, imageUrl, title, detials, startDate, time, paybaleAmount, id, handleBookingButtton, key, className, isMainScreen, parkingPrice, selectEventType,
    sessionDetails, displayQr, hidePaymentDetails, paymentResponse, page, qrCodeValue, isCrousalEvent, facilitiesName, eventViewStyle, facilityPrice, passDetails, passId,
    isMultiplefacility, isPass, isBookingClosed: isBookingClosedProp, dispatch, notify, currentFacilityID, selectedAmenities }) {
    let currentFilpass = passDetails?.filter((item) => {
        return item.id == passId
    })
    // console.log('eventIndex',eventIndex)
    let linkFacility = []
    let localLinkFacility = JSON.parse(localStorage.getItem('selectEventLinkFacility'))
    let allLinkFacility = allFacility?.length > 0 ? allFacility : localLinkFacility
    allLinkFacility?.length > 0 ? allLinkFacility.map((v) => {
        linkFacility.push(v?.full_name)
    }) : null

    const [currentpass, setCurrentPass] = useState(EMPTY_OBJECT)
    // Local state to manage Sold Out button (for main screen)
    const [localIsBookingClosed, setLocalIsBookingClosed] = useState(isBookingClosedProp)

    useEffect(() => {
        // setCurrentPass(currentFilpass[0])
        setCurrentPass(currentFilpass?.[0])
    }, [])

    // Keep in sync if prop changes from parent
    useEffect(() => {
        setLocalIsBookingClosed(isBookingClosedProp)
    }, [isBookingClosedProp])

    const handleBooking = (id, event = '', allFacility = []) => {
        const localFacilityId = JSON.parse(localStorage.getItem('selectedFacilityId'))
        const cur_facility_Id = currentFacilityID ? currentFacilityID : allFacility?.[0]?.id ? allFacility?.[0]?.id : localFacilityId
        localStorage?.setItem('selectedFacilityId', cur_facility_Id)
        localStorage?.setItem('selectEventLinkFacility', JSON.stringify(allFacility))

        localStorage?.setItem('selectEventType', 'event')
        localStorage?.setItem('booking_event', id)
        dispatch(globalKeyStore({ selectedEventId: id }))

        let end_time = event?.end_time
        if (end_time) {
            localStorage.setItem('end_time', end_time)
        }
        const factimeZone = allFacility?.filter((item) => {
            return item?.id == currentFacilityID
        })
        let facilityTimeZone = factimeZone.length > 0 ? factimeZone[0]?.timezone : allFacility?.[0]?.timezone ? allFacility?.[0]?.timezone : 'America/New_York'
        let isBookingClosedCheck = isTimeBeforeCurrentFacilityTime(event?.stop_event_booking_time, facilityTimeZone)

        let eventLinkFacilityId = allFacility?.filter(facility => facility?.id == cur_facility_Id)        
        if (isBookingClosedCheck) {
            // Set internal state so Sold Out button appears immediately
            setLocalIsBookingClosed(true)
            notify('error', errorMessages?.soldOutError)
        } else {
            handleBookingButtton(id, eventLinkFacilityId?.length > 0 ? cur_facility_Id : allFacility?.[0]?.id )
        }
    }

    // amenities booked with the reservation (event-booking-web response)
    const reservationAmenities = Array.isArray(paymentResponse?.reservation_amenities) ? paymentResponse?.reservation_amenities : EMPTY_ARRAY
    const renderReservationAmenities = () => reservationAmenities.length > 0 ? <p className='mb-2'>
        <b>Amenities - </b>
        {reservationAmenities.map((item, index) => {
            const amenityName = item?.amenity?.name || item?.amenity_name || item?.name
            const amenityPrice = item?.price ?? item?.amount
            return <span key={'reservation_amenity_' + index}>
                {index > 0 ? ', ' : ''}{amenityName}{amenityPrice !== undefined && amenityPrice !== null ? ` ($${getFormattedAmountNumber(amenityPrice)})` : ''}
            </span>
        })}
    </p> : null

    // currentpass[0]?.pass_type_slug === EVENT_TYPES?.BUNDLE_PASS && currentpass[0]?.is_full_season == 0
    return (

        <div className={(className) ? className : 'col'} key={key}>
            {/* For details page */}

            {(page == 'details') ?
                <div className="card h-100">
                    <div className="row g-0">

                        <div className="col-md-4 border-end">
                            {/* <div className='w-100 h-100' style={{ backgroundImage: 'url(' + imageUrl + ')', backgroundSize: '150px', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', minHeight: '200px' }}> */}
                            <div className='w-100 h-100 text-center d-flex justify-content-center align-items-center'>
                                {imageUrl === 'NoImage' ? <NoImage /> : <img src={imageUrl} className='img-fluid' />}
                            </div>
                        </div>
                        <div className=" col-md-8">
                            <div className='card-body'>
                                {paymentResponse?.ticketech_code ? <p className='mb-2 fw-bold'>Booking ID - {paymentResponse?.ticketech_code}</p> : ''}
                                {renderReservationAmenities()}
                                <h4 className="card-title mb-2 fw-bold text-primary">{title}</h4>
                                {detials != '' && <div className='card-text-wrapper details'><p className="card-text mb-1 max-width-40vw" dangerouslySetInnerHTML={{ __html: detials }} /></div>}
                                {(paymentResponse?.event_type !== 'simple-pass' && paymentResponse?.event_type !== 'party-pass' && paymentResponse?.event_type !== 'bundle-pass') && <p className="fw-bold m-0 d-flex align-items-center gap-1 "><i className="fa fa-map-marker"></i> {facilitiesName}
                                    {isMultiplefacility ? <a type='button' className={'my-anchor-element' + eventIndex}><img className='' style={{ marginTop: '-5px', height: '25px' }} src={moreIcon} ></img></a> : null}
                                </p>}


                                <div className="d-sm-flex border rounded"><h5 className="fw-light m-0 border-end p-2 w-100"><i className="fa fa-calendar me-2"></i> {moment(startDate)?.format('dddd Do MMM, YYYY')} </h5><div className="w-100 border-bottom d-block d-sm-none"></div><h5 className="fw-light m-0 p-2 w-100"><b className="fw-bold me-2">Event Start At - </b><i className="fa fa-clock me-2"></i> {moment(startDate).format('hh:mm A')} </h5></div>
                                <p className='small mt-2'>{`*Event parking starts at  ${moment(
                                    time?.parking_start_time
                                ).format('MM/DD/YYYY hh:mm A')} & ends at  ${moment(
                                    time?.parking_end_time
                                ).format('MM/DD/YYYY hh:mm A')}`}</p>

                                {/* {(currentpass?.pass_type_slug == EVENT_TYPES?.BUNDLE_PASS) ? */}
                                <div className={` block flex-grow-1 ${(eventViewStyle == 'list') ? 'order-sm-3' : 'order-sm-3'} `}>
                                    {isMainScreen ?
                                        <div className="d-flex justify-content-between">
                                            <div className="h2 fw-bold text-dark m-0">${Number(paybaleAmount) > 0 || (Number(facilityPrice) === 0 && Number(paybaleAmount) === 0) ? getFormattedAmountNumber(paybaleAmount) : getFormattedAmountNumber(facilityPrice)}{/* <small className="fw-light" style={{ fontSize: '1rem' }}>+ tax</small>*/}</div>
                                            {
                                                (localIsBookingClosed && localStorage.getItem('selectEventType')!='pass')
                                                    ? <button type='button' className="btn btn-secondary" disabled>Sold Out</button>
                                                    : <button type='button' className="btn btn-primary" onClick={() => handleBooking(id, time)}>Book Parking</button>
                                            }
                                        </div> :
                                        hidePaymentDetails ? null : <div className="bill-card">
                                            {parkingPrice !== undefined && <div className="row align-items-center fw-bold text-primary">
                                                <div className="col text-start">Parking Price{/* Including Tax*/}</div>
                                                <div className="col text-end">{`$${Number(parkingPrice) > 0 || (Number(parkingPrice) === 0 && Number(facilityPrice) === 0) ? getFormattedAmountNumber(parkingPrice) : getFormattedAmountNumber(facilityPrice)}`}</div>
                                            </div>}
                                            {getPriceBreakdown(sessionDetails)}
                                        </div>}
                                </div>
                                {/* : '' } */}
                            </div>

                            {((selectEventType == 'event' && !isMainScreen && !isCrousalEvent) || (!isCrousalEvent && paymentResponse?.total)) && <div className="card-footer p-3 bg-info bg-opacity-10">
                                <div className="row">
                                    <div className="col text-start">
                                        <p className="lead fw-bold m-0">Total{selectedAmenities?.length > 0 && <small className="fw-normal fs-6 ms-1" style={{ color: 'red' }}>(*Amenity fee applied)</small>}</p>
                                    </div>
                                    <div className="col text-end">
                                        <p className="lead m-0 fw-bold">{`$${sessionDetails?.data?.amount || sessionDetails?.data?.amount == 0 ? getFormattedAmountNumber(sessionDetails?.data?.amount) : getFormattedAmountNumber(paymentResponse?.total)}`}</p>
                                    </div>
                                </div>
                            </div>}

                            {displayQr ? <div className="col-sm-2 text-center bg-light border-start p-3">
                                {(paymentResponse?.mapco_qrcode?.length > 0) && (qrCodeValue) && (
                                    <QRCodeSVG
                                        value={qrCodeValue}
                                        width="100%"
                                        height="70%"
                                    // size={180}
                                    />
                                )}
                                <h4 className="fw-bold mt-3 mb-0">{qrCodeValue}</h4>
                            </div> : null}
                        </div>

                    </div></div>
                : (page == 'success') ? <div className="card h-100">
                    <div className="row g-0">

                        <div className="col-md-3 border-end">
                            {/* <div className='w-100 h-100' style={{ backgroundImage: 'url(' + imageUrl + ')', backgroundSize: '150px', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', minHeight: '200px' }}> */}
                            <div className='w-100 h-100 text-center p-4 ps-sm-0 d-flex justify-content-center align-items-center'>
                                {imageUrl === 'NoImage' ? <NoImage /> : <img src={imageUrl} className='w-100 ' style={{ objectFit: 'fill' }} />}
                            </div>
                        </div>
                        <div className=" col-md-7">
                            <div className='card-body'>
                                {(paymentResponse?.ticketech_code || paymentResponse?.event_type === 'simple-pass') ? <p className='mb-2 fw-bold'>Booking ID - {paymentResponse?.ticketech_code || paymentResponse?.pass_code}</p> : ''}
                                {renderReservationAmenities()}
                                <h4 className="card-title mb-2 fw-bold text-primary">{paymentResponse?.event_type === 'simple-pass' ? detials : title}</h4>
                                {(detials != '' && paymentResponse?.event_type !== 'simple-pass') && <div className='card-text-wrapper'><p className="card-text mb-1 max-width-40vw" dangerouslySetInnerHTML={{ __html: detials }} /></div>}
                                {(facilitiesName && (paymentResponse?.event_type !== 'simple-pass' && paymentResponse?.event_type !== 'party-pass' && paymentResponse?.event_type !== 'bundle-pass')) && <p className={`${paymentResponse?.event_type === 'simple-pass' ? 'mb-0' : ''} fw-bold m-0 d-flex align-items-center gap-1`}><i className="fa fa-map-marker"></i> {facilitiesName}
                                    {isMultiplefacility ? <a type='button' className={'my-anchor-element' + eventIndex}><img className='' style={{ marginTop: '-5px', height: '25px' }} src={moreIcon} ></img></a> : null}
                                </p>}
                                {paymentResponse?.event_type === 'simple-pass' ? <p className="fw-bold "><i className="fa-solid fa-ticket"></i> Total Usage - {paymentResponse?.total_days}</p> : ''}


                                {paymentResponse?.event_type === 'simple-pass' ? <div className="d-sm-flex border rounded"><h5 className="fw-light m-0 p-2 w-100"><i className="fa fa-calendar me-2"></i> Valid till {moment(paymentResponse?.end_date)?.format('dddd Do MMM, YYYY')} </h5></div> : <div className="d-sm-flex border rounded"><h5 className="fw-light m-0 border-end p-2 w-100"><i className="fa fa-calendar me-2"></i> {moment(startDate)?.format('dddd Do MMM, YYYY')} </h5><div className="w-100 border-bottom d-block d-sm-none"></div><h5 className="fw-light m-0 p-2 w-100"><b className="fw-bold me-2">Event Start At - </b><i className="fa fa-clock me-2"></i> {moment(startDate).format('hh:mm A')} </h5></div>}

                                {paymentResponse?.event_type !== 'simple-pass' && <p className='small mt-2'>{`*Parking starts at  ${moment(
                                    paymentResponse?.start_timestamp
                                ).format('MM/DD/YYYY hh:mm A')} & ends at  ${moment(
                                    paymentResponse?.end_timestamp
                                ).format('MM/DD/YYYY hh:mm A')}`}</p>}

                                {(currentpass?.pass_type_slug == EVENT_TYPES?.BUNDLE_PASS) ? <div className={` block flex-grow-1 ${(eventViewStyle == 'list') ? 'order-sm-3' : 'order-sm-3'} `}>
                                    {isMainScreen ?
                                        <div className="d-flex justify-content-between">
                                            <div className="h2 fw-bold text-dark m-0">${Number(paybaleAmount) > 0 || (Number(facilityPrice) === 0 && Number(paybaleAmount) === 0) ? getFormattedAmountNumber(paybaleAmount) : getFormattedAmountNumber(facilityPrice)}{/* <small className="fw-light" style={{ fontSize: '1rem' }}>+ tax</small>*/}</div>
                                            {
                                                localIsBookingClosed
                                                    ? <button type='button' className="btn btn-secondary" disabled>Sold Out</button>
                                                    : <button type='button' className="btn btn-primary" onClick={() => handleBooking(id, time)}>Book Parking</button>
                                            }
                                        </div> :
                                        hidePaymentDetails ? null : <div className="bill-card">
                                            {(parkingPrice !== undefined) && <div className="row mb-1 align-items-center fw-bold text-primary">
                                                <div className="col text-start">Parking Price{/* Including Tax*/}</div>
                                                <div className="col text-end">{`$${Number(parkingPrice) > 0 || (Number(parkingPrice) === 0 && Number(facilityPrice) === 0) ? getFormattedAmountNumber(parkingPrice) : getFormattedAmountNumber(facilityPrice)}`}</div>
                                            </div>}
                                            {getPriceBreakdown(sessionDetails)}
                                        </div>}
                                </div> : ''}
                            </div>

                            {((selectEventType == 'event' && !isMainScreen && !isCrousalEvent) || (!isCrousalEvent && (paymentResponse?.total || paymentResponse?.total === 0))) ? <div className="card-footer p-3 bg-info bg-opacity-10">
                                <div className="row">
                                    <div className="col text-start">
                                        <p className="lead fw-bold m-0">Total{selectedAmenities?.length > 0 && <small className="fw-normal fs-6 ms-1" style={{ color: 'red' }}>(*Amenity fee applied)</small>}</p>
                                    </div>
                                    <div className="col text-end">
                                        <p className="lead m-0 fw-bold">{`$${sessionDetails?.data?.amount || sessionDetails?.data?.amount == 0 ? getFormattedAmountNumber(sessionDetails?.data?.amount) : getFormattedAmountNumber(paymentResponse?.total)}`}</p>
                                    </div>
                                </div>
                            </div> : ''}


                        </div>
                        {(displayQr && qrCodeValue) ? <div className="col-sm-2 text-center bg-light border-start p-3">
                            {(paymentResponse?.event_type === 'simple-pass' || paymentResponse?.mapco_qrcode?.length > 0) && (
                                <QRCodeSVG
                                    value={qrCodeValue}
                                    width="100%"
                                    height="70%"
                                // size={180}
                                />
                            )}
                            <h4 className="fw-bold mt-3 mb-0">{qrCodeValue}</h4>
                        </div> : null}

                    </div></div> : <div className="card projectCard h-100">
                    <div className='p-2 px-4'>
                        <div className={`row listingBlock  align-items-center   ${(eventViewStyle == 'list') ? ' blocklist align-sm-items-center' : ' blockcolumns '}   `}>

                            <div className={` ${(eventViewStyle == 'list') ? 'order-sm-1  col-md-3' : 'order-sm-0  col-md'} `}>
                                {paymentResponse?.ticketech_code ? <p className='mb-2 fw-bold'>Booking ID - {paymentResponse?.ticketech_code}</p> : ''}
                                {renderReservationAmenities()}
                                <h4 className="card-title m-0 fw-bold text-primary">{title}</h4>
                                {detials != '' && <div className='card-text-wrapper'><p className="card-text mb-1 max-width-40vw" dangerouslySetInnerHTML={{ __html: detials }} /></div>}
                                {(paymentResponse?.event_type !== 'simple-pass' && paymentResponse?.event_type !== 'party-pass' && paymentResponse?.event_type !== 'bundle-pass') && <p className={`fw-bold m-0 d-flex align-items-center gap-1 ${isPass ? 'd-none' : ''}`}><i className="fa fa-map-marker"></i> {facilitiesName}
                                    {/* //Hiding in Case of Pass Events after discussion with Trapti Mam, 27thJan Deployment */}
                                    {isMultiplefacility ? <a type='button' className={'my-anchor-element' + eventIndex}><img className='' style={{ marginTop: '-5px', height: '25px' }} src={moreIcon} ></img></a> : null}
                                </p>}
                            </div>

                            <div className={`  blockImg h-100 rounded border d-flex align-items-center widthVar justify-content-center  ${(eventViewStyle == 'list') ? 'order-sm-0 col-md-2' : 'order-sm-1 col-md'} `}>
                                {/* <div className='w-100 h-100' style={{ backgroundImage: 'url(' + imageUrl + ')', backgroundSize: '150px', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', minHeight: '200px' }}> */}

                                {imageUrl === 'NoImage' ? <NoImage /> : <img className='w-100 h-100' src={imageUrl} />}

                            </div>
                            <div className={`   block flex-grow-1 ${(eventViewStyle == 'list') ? 'order-sm-2 col-md-3' : 'order-sm-2 col-md'} `}>
                                <div className={` d-flex w-100 gap-3 align-items-center justify-content-between ${(eventViewStyle == 'list') ? '' : ''}`}>
                                    <div>
                                        <div className=" m-0 "><i className="fa fa-calendar "></i> {moment(startDate)?.format('dddd Do MMM, YYYY')} </div>
                                        <div className=" m-0 "><i className="fa fa-clock "></i> KickOff Time {moment(startDate)?.format(' Do MMM, YYYY')} </div>
                                        {eventViewStyle == 'list' ? <div className="m-0 small">{`*Event parking starts at  ${moment(
                                            time?.parking_start_time
                                        ).format('MM/DD/YYYY hh:mm A')} & ends at  ${moment(
                                            time?.parking_end_time
                                        ).format('MM/DD/YYYY hh:mm A')}`}</div> : ''}

                                    </div>
                                    <div className='bg-warning border rounded bg-opacity-10 border-warning text-center p-1 ' style={{ minWidth: '90px' }}>
                                        <div className="m-0 small">Event Start At </div>
                                        <div className=" m-0 fw-bold ">{moment(startDate).format('hh:mm A')} </div>

                                    </div>
                                </div>
                                {eventViewStyle != 'list' ? <p className='small mt-2'>{`*Event parking starts at  ${moment(
                                    time?.parking_start_time
                                ).format('MM/DD/YYYY hh:mm A')} & ends at  ${moment(
                                    time?.parking_end_time
                                ).format('MM/DD/YYYY hh:mm A')}`}</p> : ''}
                            </div>
                            {isMainScreen ? <div className={`  flex-grow-1 ${(eventViewStyle == 'list') ? 'order-sm-3 col-md-3' : 'order-sm-3 col-md'} `}>
                                {isMainScreen ?
                                    <div className="d-flex justify-content-between">
                                        <div className="h2 fw-bold text-dark m-0">${Number(paybaleAmount) > 0 || (Number(facilityPrice) === 0 && Number(paybaleAmount) === 0) ? getFormattedAmountNumber(paybaleAmount) : getFormattedAmountNumber(facilityPrice)}{/* <small className="fw-light" style={{ fontSize: '1rem' }}>+ tax</small>*/}</div>
                                        {
                                            localIsBookingClosed
                                                ? <button type='button' className="btn btn-secondary" disabled>Sold Out</button>
                                                : <button type='button' className="btn btn-primary" onClick={() => handleBooking(id, time, allFacility)}>Book Parking</button>
                                        }
                                    </div> :
                                    hidePaymentDetails ? null : <div className="bill-card">
                                        {parkingPrice !== undefined && <div className="row mb-1 align-items-center fw-bold text-primary">
                                            <div className="col text-start">Parking Price{/* Including Tax*/}</div>
                                            <div className="col text-end">{`$${Number(parkingPrice) > 0 || (Number(parkingPrice) === 0 && Number(facilityPrice) === 0) ? getFormattedAmountNumber(parkingPrice) : getFormattedAmountNumber(facilityPrice)}`}</div>
                                        </div>}
                                        {getPriceBreakdown(sessionDetails)}
                                    </div>}
                            </div> : ''}


                            {((selectEventType == 'event' && !isMainScreen && !isCrousalEvent) || (!isCrousalEvent && paymentResponse?.total)) && <div className="card-footer p-3 bg-info bg-opacity-10">
                                <div className="row">
                                    <div className="col text-start">
                                        <p className="lead fw-bold m-0">Total{selectedAmenities?.length > 0 && <small className="fw-normal fs-6 ms-1" style={{ color: 'red' }}>(*Amenity fee applied)</small>}</p>
                                    </div>
                                    <div className="col text-end">
                                        <p className="lead m-0 fw-bold">{`$${sessionDetails?.data?.amount || sessionDetails?.data?.amount == 0 ? getFormattedAmountNumber(sessionDetails?.data?.amount) : getFormattedAmountNumber(paymentResponse?.total)}`}</p>
                                    </div>
                                </div>
                            </div>}

                            {displayQr ? <div className="col-sm-2 text-center bg-light border-start p-3">
                                {(paymentResponse?.mapco_qrcode?.length > 0) && (qrCodeValue) && (
                                    <QRCodeSVG
                                        value={qrCodeValue}
                                        width="100%"
                                        height="70%"
                                    // size={180}
                                    />
                                )}
                                <h4 className="fw-bold mt-3 mb-0">{qrCodeValue}</h4>
                            </div> : null}
                        </div>
                    </div>
                </div>}

            <Tooltip style={{ zIndex: '1050' }} anchorSelect={'.my-anchor-element' + eventIndex} place="top">
                <b>{linkFacility?.length > 1 ? 'All Garages' : 'Garage'} Linked with this Event is below.</b>
                <ul className='p-2 m-0'>
                    {linkFacility?.map((v, i) => {
                        return (<li key={i}>{v}</li>)
                    })
                    }

                </ul>
            </Tooltip>
        </div>
    )
}

EventCard.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    imageUrl: PropTypes.string,
    title: PropTypes.string,
    detials: PropTypes.string,
    startDate: PropTypes.string,
    time: PropTypes.object,
    paybaleAmount: PropTypes.string,
    id: PropTypes.number,
    handleBookingButtton: PropTypes.func,
    key: PropTypes.number,
    eventIndex: PropTypes.number,
    className: PropTypes.string,
    isMainScreen: PropTypes.bool,
    bookingFormPage: PropTypes.number,
    parkingPrice: PropTypes.string,
    tax_rate: PropTypes.string,
    // amount: PropTypes.string,
    selectEventType: PropTypes.string,
    sessionDetails: PropTypes.object,
    displayQr: PropTypes.bool,
    hidePaymentDetails: PropTypes.bool,
    paymentResponse: PropTypes.object,
    qrCodeValue: PropTypes.string,
    isCrousalEvent: PropTypes.bool,
    eventViewStyle: PropTypes.string,
    facilitiesName: PropTypes.string,
    facilityPrice: PropTypes.string,
    end_time: PropTypes.string,
    typeDetails: PropTypes.string,
    passId: PropTypes.string,
    page: PropTypes.string,
    passDetails: PropTypes.array,
    passData: PropTypes.object,
    allFacility: PropTypes.array,
    isMultiplefacility: PropTypes.bool,
    isPass: PropTypes.bool,
    isBookingClosed: PropTypes.bool,
    currentFacilityID: PropTypes.string,
    selectedAmenities: PropTypes.array,
}
EventCard.defaulProps = {
    dispatch: noop,
    imageUrl: '',
    notify: noop,
    title: '',
    detials: '',
    startDate: '',
    time: '',
    paybaleAmount: '',
    id: '',
    handleBookingButtton: noop,
    key: 0,
    eventIndex: 0,
    className: '',
    isMainScreen: false,
    bookingFormPage: 0,
    parkingPrice: 0,
    tax_rate: 0,
    // amount: 0,
    selectEventType: '',
    sessionDetails: EMPTY_OBJECT,
    displayQr: false,
    hidePaymentDetails: false,
    paymentResponse: EMPTY_OBJECT,
    qrCodeValue: '',
    isCrousalEvent: false,
    eventViewStyle: '',
    facilitiesName: '',
    facilityPrice: '',
    end_time: '',
    typeDetails: '',
    passId: '',
    page: '',
    passDetails: EMPTY_ARRAY,
    passData: EMPTY_OBJECT,
    allFacility: EMPTY_ARRAY,
    isMultiplefacility: false,
    isPass: false,
    isBookingClosed: false,
    currentFacilityID: '',
    selectedAmenities: EMPTY_ARRAY
}


function mapStateToProps({ globalReducers, mainReducer }) {
    return {
        selectedPassType: globalReducers?.selectedPassType,
        eventData: globalReducers?.eventData,
        noOfEventShow: globalReducers?.noOfEventShow,
        bookingFormPage: globalReducers?.bookingFormPage,
        selectEventType: globalReducers?.selectEventType,
        sessionDetails: globalReducers?.sessionDetails,
        eventViewStyle: globalReducers?.eventViewStyle,
        passDetails: mainReducer?.passDetails,
        passData: globalReducers?.passData,
        selectedAmenities: globalReducers?.selectedAmenities,
    }
}

export default connect(mapStateToProps)(EventCard)